import type { FC } from 'react';
import { Picture } from '@ui';
import icons from '@icons';
import { observer } from 'mobx-react';
import type { GetPeopleSearchQueriesQuery } from '@schema/cart';
import './index.scss';

const {
  close: { darkGrey: closeDGOutlined }
} = icons.Outline;

interface SearchQueriesListProps {
  searchQueries: NonNullable<
    GetPeopleSearchQueriesQuery['getPeopleSearchQueries']
  >;
  onChangeLink: (link: string) => void;
  onRemove: (queryId: number) => void;
}

const SearchQueriesList: FC<SearchQueriesListProps> = ({
  searchQueries,
  onChangeLink,
  onRemove
}) => (
  <div className='flex flex-wrap w-full gap-2 text-[var(--main-font-color)]'>
    {searchQueries.map(item => (
      <div
        key={item.id}
        className='flex items-center text-sm bg-[var(--light-grey)] rounded-lg leading-none cursor-pointer hover:bg-[var(--dark-grey)] transition-colors'
      >
        <div
          onClick={() => {
            onChangeLink(item.query || '');
          }}
          className='max-w-[320px] line-clamp-1 text-ellipsis py-2 pl-2 '
        >
          {item.query}
        </div>
        <Picture
          onClick={() => {
            onRemove(item.id);
          }}
          pictureClassName='p-2'
          icon={closeDGOutlined}
          height={16}
          width={16}
        />
      </div>
    ))}
  </div>
);

export default observer(SearchQueriesList);
